<script>
    import { resolveExportUrl } from "../../router.js";
    import wrappedFetch from "../../wrappedFetch.js";
    import { onMount } from "svelte";
    import Spinner from "../components/spinner.svelte";
    import LogDetails from "../components/logdetails.svelte";
    import ExportUsers from "./exportusermatch.svelte";
    let unmatchedUsers = [];
    let isPageLoading = true;
    export let role;
    role = role.charAt(0).toUpperCase() + role.slice(1);
    export let providerId;
    let titleProvider =  providerId == 1?"Google" :providerId == 3?"Microsoft":"";
    const getExportPendingUsers = async () => {
        let resp = await wrappedFetch(
            `/api/cloudConfig/GetPendingUsersByRole?providerId=${providerId}&role=${role}`,
            {
                method: "post",
            }
        );      
        unmatchedUsers = await resp.json();
        isPageLoading = false;
        return unmatchedUsers;
    };

    onMount(() =>
    {
      getExportPendingUsers();
});
</script>

<svelte:head>
<title> {role} Matches | {titleProvider} | Wavenet Nimbus </title>
</svelte:head>

{#if isPageLoading}
    <Spinner />
{:else}
    <LogDetails backURL={resolveExportUrl(providerId, '/logs')}>
        <div slot="title">
            <h1>{role} Logs</h1>
            <p>If an account already exists with the same or similar details, manual matching is required. To do this simply select "match options" next to the user's name and then choose the appropriate option.</p>
        </div>
        <div slot="tab1Header">Match</div>
        <div slot="tab1Content">
            <ExportUsers
                {unmatchedUsers}
                {providerId}
                role={role}
                onGetUnmatchedUsers={getExportPendingUsers} />
        </div>
    </LogDetails>
{/if}
